const FILTER = 'filter';
const CHANGE = 'change';

export { CHANGE, FILTER };
